import { render, staticRenderFns } from "./TestHistory.vue?vue&type=template&id=6b22c3a8&scoped=true"
import script from "./TestHistory.vue?vue&type=script&lang=js"
export * from "./TestHistory.vue?vue&type=script&lang=js"
import style0 from "./TestHistory.vue?vue&type=style&index=0&id=6b22c3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22c3a8",
  null
  
)

export default component.exports